import React from "react";
import html2canvas from "html2canvas";

// Shared "share transaction as image" helpers. Previously copy-pasted into
// deposits-withdraws / mismatch / center-configs / Navbar — keep the single
// source of truth here.

// Convert a base64 data URL (data:image/png;base64,...) into a Blob.
export const base64ToBlob = (base64) => {
  const byteString = atob(base64.split(",")[1]);
  const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};

// Capture a DOM element into a PNG data URL. Waits a tick so any pending
// render/paint (e.g. modal content) settles before the snapshot.
export const captureShareImage = async (element, opts = {}) => {
  if (!element) return null;
  await new Promise((r) => setTimeout(r, 300));
  const canvas = await html2canvas(element, {
    useCORS: true,
    scale: 2,
    backgroundColor: null,
    logging: false,
    ...opts,
  });
  return canvas.toDataURL("image/png");
};

// Send a captured image to a Telegram chat via the bot sendPhoto API.
export const sendShareToTelegram = async (chatId, caption, image, filename = "noti.png") => {
  const blob = base64ToBlob(image);
  const formData = new FormData();
  formData.append("chat_id", chatId);
  formData.append("caption", caption);
  formData.append("photo", blob, filename);
  return fetch(
    `https://api.telegram.org/bot${atob(global.token_chat)}/sendPhoto`,
    { method: "POST", body: formData }
  );
};

// Trigger a browser download of a captured image.
export const downloadShareImage = (image, filename = "noti.png") => {
  const blob = base64ToBlob(image);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// "deposit" + "success" -> "Deposit Successful"
export const getShareTitle = (type, status) => {
  const statusLabels = {
    pending: "Pending",
    success: "Successful",
    mismatch: "Mismatch",
    cancel: "Cancelled",
    "pending-refund": "Pending Refund",
    refund: "Refunded",
  };
  const formattedType = type.charAt(0).toUpperCase() + type.slice(1);
  const statusText = statusLabels[status] || "Processing";
  return `${formattedType} ${statusText}`;
};

const SHARE_STATUS_COLORS = {
  pending: { color: "#cfe2ff", text_color: "#0d6efd" },
  success: { color: "#e3fff7", text_color: "#2ec4b6" },
  mismatch: { color: "#ebd3f4", text_color: "#bb6ad9" },
  cancel: { color: "#fce6e6", text_color: "#eb5757" },
  "pending-refund": { color: "#f5d8e7", text_color: "#d63384" },
  refund: { color: "#cff4fc", text_color: "#56ccf2" },
};

// Colored status badge used inside the shared image.
export const StatusTnxShare = (status) => {
  const { color, text_color } = SHARE_STATUS_COLORS[status] || {};
  return (
    <div className="d-flex">
      <span
        className="px-2 pt-0 rounded-4 text-nowrap d-flex text-12 mx-1"
        style={{
          padding: "2px 0 0 2px",
          backgroundColor: color || "#f0f0f0",
          color: text_color || "#000",
          border: `1px solid ${text_color || "#f0f0f0"}`,
        }}
      >
        {status}
      </span>
    </div>
  );
};
